// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: 12VCshRIS_

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicFeedModeIcon.module.css"; // plasmic-import: 12VCshRIS_/css

createPlasmicElementProxy;

export type PlasmicFeedModeIcon__VariantMembers = {
  selected: "selected";
  color: "blue" | "red";
};
export type PlasmicFeedModeIcon__VariantsArgs = {
  selected?: SingleBooleanChoiceArg<"selected">;
  color?: MultiChoiceArg<"blue" | "red">;
};
type VariantPropType = keyof PlasmicFeedModeIcon__VariantsArgs;
export const PlasmicFeedModeIcon__VariantProps = new Array<VariantPropType>(
  "selected",
  "color"
);

export type PlasmicFeedModeIcon__ArgsType = {};
type ArgPropType = keyof PlasmicFeedModeIcon__ArgsType;
export const PlasmicFeedModeIcon__ArgProps = new Array<ArgPropType>();

export type PlasmicFeedModeIcon__OverridesType = {
  root?: p.Flex<"button">;
  freeBox?: p.Flex<"div">;
};

export interface DefaultFeedModeIconProps {
  selected?: SingleBooleanChoiceArg<"selected">;
  color?: MultiChoiceArg<"blue" | "red">;
  className?: string;
}

const $$ = {};

function PlasmicFeedModeIcon__RenderFunc(props: {
  variants: PlasmicFeedModeIcon__VariantsArgs;
  args: PlasmicFeedModeIcon__ArgsType;
  overrides: PlasmicFeedModeIcon__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "selected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.selected
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.color
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <p.Stack
      as={"button"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootcolor_red]: hasVariant($state, "color", "red"),
          [sty.rootselected]: hasVariant($state, "selected", "selected")
        }
      )}
    >
      <p.PlasmicImg
        alt={""}
        className={classNames(sty.img__ljT9, {
          [sty.imgcolor_blue__ljT9L7Nmm]: hasVariant($state, "color", "blue"),
          [sty.imgcolor_red__ljT9Wz5RI]: hasVariant($state, "color", "red"),
          [sty.imgselected__ljT9IQxya]: hasVariant(
            $state,
            "selected",
            "selected"
          )
        })}
        displayHeight={"33px"}
        displayMaxHeight={"none"}
        displayMaxWidth={
          hasVariant($state, "selected", "selected") ? "none" : "none"
        }
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={
          hasVariant($state, "selected", "selected") ? "45px" : "45px"
        }
        loader={"plasmic"}
        loading={"lazy"}
        src={{
          src: "https://site-assets.plasmic.app/4d4bee04f6b6992c12ff113456d01928.svg",
          fullWidth: 117,
          fullHeight: 150,
          aspectRatio: 0.779661
        }}
      />

      <p.PlasmicImg
        alt={""}
        className={classNames(sty.img__oPIkp, {
          [sty.imgcolor_red__oPIkpwz5RI]: hasVariant($state, "color", "red"),
          [sty.imgselected_color_red__oPIkpIQxyaWz5RI]:
            hasVariant($state, "selected", "selected") &&
            hasVariant($state, "color", "red")
        })}
        displayHeight={"40px"}
        displayMaxHeight={"none"}
        displayMaxWidth={"none"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={"45px"}
        loader={"plasmic"}
        loading={"lazy"}
        src={{
          src: "https://site-assets.plasmic.app/c70ca816f6bac400665b25c3ca4a6282.svg",
          fullWidth: 119,
          fullHeight: 150,
          aspectRatio: 0.793103
        }}
      />

      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxselected]: hasVariant($state, "selected", "selected"),
          [sty.freeBoxselected_color_red]:
            hasVariant($state, "selected", "selected") &&
            hasVariant($state, "color", "red")
        })}
      />
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFeedModeIcon__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFeedModeIcon__VariantsArgs;
    args?: PlasmicFeedModeIcon__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicFeedModeIcon__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicFeedModeIcon__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFeedModeIcon__ArgProps,
          internalVariantPropNames: PlasmicFeedModeIcon__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFeedModeIcon__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicFeedModeIcon";
  } else {
    func.displayName = `PlasmicFeedModeIcon.${nodeName}`;
  }
  return func;
}

export const PlasmicFeedModeIcon = Object.assign(
  // Top-level PlasmicFeedModeIcon renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicFeedModeIcon
    internalVariantProps: PlasmicFeedModeIcon__VariantProps,
    internalArgProps: PlasmicFeedModeIcon__ArgProps
  }
);

export default PlasmicFeedModeIcon;
/* prettier-ignore-end */
